import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";

// Model
import { roles } from "../../model/data";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import { Fade, Grid, Divider, Typography } from "@mui/material";

const Item = ({ data = {}, startTransition }) => {
  return (
    <>
      {Object.keys(data).map((roleTitle) => {
        const r = data[roleTitle];
        return (
          <>
            <Fade in={startTransition} timeout={4500}>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  margin:
                    roleTitle === "secondary sponsors" ? "0px" : "20px 0px",
                  marginTop: "20px",
                }}
              >
                {roleTitle}
              </Typography>
            </Fade>

            {Array.isArray(r) ? (
              <Fade in={startTransition} timeout={5500}>
                <Grid
                  container
                  spacing={2}
                  direction={`${r.length > 2 ? "column" : "row"}`}
                  zeroMinWidth={true}
                >
                  {r.map((name, index) => (
                    <Grid item key={index}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        style={{
                          fontSize: "14px",
                          marginBottom: "5px",
                        }}
                      >
                        {Array.isArray(name) ? name.join(` & `) : name}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </Fade>
            ) : null}
          </>
        );
      })}
    </>
  );
};

const Roles = (props) => {
  const contentRef = useRef();
  const [startTransition, setStartTransition] = useState(false);
  const { inViewport } = useInViewport(contentRef);
  const { device } = useDevice();

  useEffect(() => {
    if (inViewport) setStartTransition(true);
  }, [inViewport]);

  return (
    <div {...props} className={`vjc_main-roles ${device}`}>
      <Divider sx={{ marginBottom: "50px" }}>
        <Typography variant="h1" sx={{ fontSize: "26px" }}>
          {roles.name}
        </Typography>
      </Divider>

      <Fade in={startTransition} timeout={2500}>
        <Typography
          variant="body2"
          color="text.secondary"
          style={{
            fontSize: "14px",
            fontWeight: "700",
            marginBottom: "10px",
          }}
          ref={contentRef}
        >
          {roles.title}
        </Typography>
      </Fade>

      <Fade in={startTransition} timeout={2500}>
        <Typography
          variant="body2"
          color="text.secondary"
          style={{
            fontSize: "14px",
            marginBottom: "10px",
          }}
        >
          {roles.description}
        </Typography>
      </Fade>

      <Item
        data={roles.roles}
        startTransition={startTransition}
        key={"principal"}
      />

      <Item
        data={roles.roles["secondary sponsors"]}
        startTransition={startTransition}
        key={"secondary"}
      />
    </div>
  );
};

export default Roles;
